import { render, staticRenderFns } from "./employees.vue?vue&type=template&id=244625d1&scoped=true&"
import script from "./employees.vue?vue&type=script&lang=js&"
export * from "./employees.vue?vue&type=script&lang=js&"
import style0 from "./employees.vue?vue&type=style&index=0&id=244625d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244625d1",
  null
  
)

export default component.exports